import { type FetchResult, gql, type MutationHookOptions, type TypedDocumentNode, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { ClearAiForwardingConfirmation, ClearAiForwardingConfirmationVariables } from 'types/graphql';

const CLEAR_FORWARDING_CONFIRMATION_MUTATION: TypedDocumentNode<
  ClearAiForwardingConfirmation,
  ClearAiForwardingConfirmationVariables
> = gql`
  mutation ClearAiForwardingConfirmation {
    clearAiForwardingConfirmation
  }
`;

type ClearOptions = Pick<
  MutationHookOptions<ClearAiForwardingConfirmation, ClearAiForwardingConfirmationVariables>,
  'onCompleted'
>;

/** Clears the pending email-forwarding confirmation after the admin approved or denied it. */
export function useClearAiForwardingConfirmation(options: ClearOptions = {}) {
  const [mutate, { loading, error }] = useMutation(CLEAR_FORWARDING_CONFIRMATION_MUTATION, options);
  const clear = useCallback((): Promise<FetchResult<ClearAiForwardingConfirmation>> => mutate(), [mutate]);

  return { clear, loading, error };
}
